(function($) {

	'use strict';

	var init = function() {
		imageHero()
		imageSavoir()
		pushAnim()
		imageAnim()
  	};

  	var imageHero = function() {

		var height = $('.fp-hero').height()
		var tl = gsap.to('.fp-hero__img', { scale: 1.2 })
		var controller = new ScrollMagic.Controller()

		var scene = new ScrollMagic.Scene({
			triggerElement: '.fp-hero',
			duration: height,
			triggerHook: 0
		})
		.setTween(tl)
		.addTo(controller)
	}

	var imageSavoir = function() {

	  var height = $('.fp-push__image').height()
	  var tl2 = gsap.to('.fp-push__img', { scale: 1.2 })
	  var controller = new ScrollMagic.Controller()

	  var scene = new ScrollMagic.Scene({
		  triggerElement: '.fp-push__image',
		  duration: height,
		  triggerHook: 0
	  })
	  .setTween(tl2)
	  .addTo(controller)
  }

  var pushAnim = function() {

	  var timeline = gsap.timeline()
	  timeline.from(".fp-push__image", {
		  scaleY: 0,
		  duration: 1,
		  ease: "power2"
	  })
	  timeline.to(".fp-push__cache", {
		  scaleY: 0,
		  duration: 1,
		  ease: "power2"
	  }, "-=0.2")
	  timeline.from(".fp-push__container", {
		  translateY: "100%",
		  opacity: 0,
		  duration: 1,
		  ease: "power2"
	  }, "-=1.2")

	  var controller = new ScrollMagic.Controller()


	  var fp_push = new ScrollMagic.Scene({
		  triggerElement: '.fp-push',
		  reverse: false
	  })
	  .setTween(timeline)
	  .addTo(controller)
  }

  var imageAnim = function() {
	var timeline2 = gsap.timeline()
	  timeline2.from(".fp-image", {
		  scaleY: 0,
		  duration: 1,
		  ease: "power2"
	  })
	  timeline2.to(".fp-image__cache", {
		  scaleY: 0,
		  duration: 1,
		  ease: "power2"
	  }, "-=0.2")

	  var controller2 = new ScrollMagic.Controller()

	  var image_appear = new ScrollMagic.Scene({
		  triggerElement: '.fp-image',
		  reverse: false
	  })
	  .setTween(timeline2)
	  .addTo(controller2)

	  var height = $('.fp-image').height()
	  var zoomIn = gsap.to('.fp-image__img', {
		  scale: 1.2
	  })

	  var zoomImage = new ScrollMagic.Scene({
		  triggerElement: '.fp-image',
		  duration: height,
		  triggerHook: 0
	  })
	  .setTween(zoomIn)
	  .addTo(controller2)
  }
  
	$(document).ready(function() {
		if($('body').hasClass('home')) {
			init();
		}
	});

})(jQuery);
